const { Trigger } = require( './lib/trigger' );

const trigger = new Trigger();
trigger.init();
